const Config = {
  // API_URL : 'https://api-molpay-dev.viewqwest.com/api/',
  // RAZER_URL: "https://sandbox.merchant.razer.com/RMS/pay/SB_ViewQwest/",

  // API_URL : 'https://api-molpay.viewqwest.com/api/',
  API_URL: "https://api-gateway.viewqwest.com/molpay/api/",
  RAZER_URL: "https://pay.merchant.razer.com/RMS/pay/fiberathome/",
  defaultPath: "/direct-pay/guest",
};

export default Config;
